import { defineMessages } from 'react-intl';

export default defineMessages({
  account: {
    id: 'sentinel.components.updateAmountForm.account',
    defaultMessage: 'Account Number',
  },
  editAccount: {
    id: 'sentinel.components.updateAmountForm.editAccount',
    defaultMessage: 'Account Details',
  },
  updateWire: {
    id: 'sentinel.components.updateAmountForm.updateWire',
    defaultMessage: 'Update Wire',
  },
  error: {
    id: 'sentinel.components.updateAmountForm.error',
    defaultMessage: 'Remove extra spaces',
  },
});



// WEBPACK FOOTER //
// ./src/components/UpdateAccountForm/messages.js